export default __webpack_public_path__ + "static/SRUS P340 - Product Specifications & Technical Data-bef460a7a7b0d7a299bd72fc5c79e1b9.pdf";